module.exports = __webpack_public_path__ + "img/broken-image.501a9686.svg";